/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("AppController", function AppController(
	$scope,
	$rootScope,
	$window,

	dxSession,
	RoleTypeEnum,
	dxKayako
) {
	"use strict";

	$scope.dxSession = dxSession;
	$scope.hideSidebar = false;
	$scope.isInternetExplorer = isInternetExplorer();
	$scope.hideKayakoButton = dxKayako.isHidden();
	$scope.newMessageCount = 0;

	$rootScope.$on("$routeChangeStart", function onRouteChangeStart(event, next) {
		if (dxSession.getRole().roleType === RoleTypeEnum.PUB) {
			$scope.hideSidebar = true;
		} else if (next && next.$$route) {
			$scope.hideSidebar = !!next.$$route.hideSidebar;
		}

		if (next && next.$$route) {
			$scope.lobby = next.$$route.lobby;
		}
	});

	// This check was based on code found here:
	// https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
	function isInternetExplorer() {
		var ua = $window.navigator.userAgent;
		return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
	}

	$scope.getRoleOrganization = function getRoleOrganization(role) {
		if (!role) {
			return "";
		}

		if (role.roleType === RoleTypeEnum.MASTER) {
			return "Digiexam Staff";
		}

		if (!role.organizationTitle) {
			// Users that does not have a student on an organization have a generic student role.
			if (role.roleType === RoleTypeEnum.STUDENT) {
				return "Student";
			}

			// There should not be any other roles without an organization,
			// but just in case, return a generic group name.
			return "Other";
		}

		return role.organizationTitle;
	};

	$scope.isStudent = function isStudent() {
		return dxSession.getRole().roleType === RoleTypeEnum.STUDENT;
	};

	$rootScope.$on("kayako.hidden", function kayakoHidden() {
		$scope.hideKayakoButton = true;
	});

	$rootScope.$on("kayako.visible", function kayakoVisible() {
		$scope.hideKayakoButton = false;
	});

	$rootScope.$on("kayako.newMessage", function kayakoNewMessage(event, count) {
		$scope.newMessageCount = count;
	});
});
